import React from "react";
// import { connect } from "react-redux";
// import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";

// import fetchTopAlbumsAction from "../api/fetchChart";

// import Loading from "../components/Loading/Loading";
// import CardAlbum from "../components/CardAlbum/CardAlbum";

const ChartAlbums = () => {
  //   constructor(props) {
  //     super(props);
  //     this.state = { index: 0 };
  //     this.handleLeft = this.handleLeft.bind(this);
  //     this.handleRight = this.handleRight.bind(this);
  //   }

  //   componentDidMount() {
  //     const { fetchTopAlbums } = this.props;
  //     fetchTopAlbums();
  //   }

  //   handleRight(total) {
  //     let limit = Math.floor(total / 2) - 1;
  //     if (this.state.index < limit) {
  //       let n = this.state.index + 1;
  //       this.setState({ index: n });
  //       document.getElementById(
  //         "carousel-top-albums"
  //       ).style.transform = `translateX(-${n * (170 + 40)}px)`;
  //     }
  //   }
  //   handleLeft() {
  //     if (this.state.index > 0) {
  //       let n = this.state.index - 1;
  //       this.setState({ index: n });
  //       document.getElementById(
  //         "carousel-top-albums"
  //       ).style.transform = `translateX(-${n * (170 + 40)}px)`;
  //     }
  //   }

  //   render() {
  //     const { albums, loading, error } = this.props;

  // if (loading) return <Loading />;
  // else {
  return (
    <div>
      {/* {error && <span>{error}</span>} */}
      <div className="header-carrousel">
        <h1>Trending Albums</h1>
        <div>
          <svg width="15" height="15" fill="currentColor" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M10 19a1 1 0 0 1-.64-.23a1 1 0 0 1-.13-1.41L13.71 12L9.39 6.63a1 1 0 0 1 .15-1.41a1 1 0 0 1 1.46.15l4.83 6a1 1 0 0 1 0 1.27l-5 6A1 1 0 0 1 10 19z"
            ></path>
          </svg>
          <svg width="15" height="15" fill="currentColor" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M13.83 19a1 1 0 0 1-.78-.37l-4.83-6a1 1 0 0 1 0-1.27l5-6a1 1 0 0 1 1.54 1.28L10.29 12l4.32 5.36a1 1 0 0 1-.78 1.64z"
            ></path>
          </svg>
        </div>
      </div>
      <section>
        <div className="slider">
          <div className="items-slider" id="carousel-top-albums">
            {/* {albums.data.map((album) => (
                  <CardAlbum key={album.id} album={album} />
                ))} */}
            {/* <Link to={`/album/${album.id}`} className="album"> */}
            {/* <img src={album.cover_medium} alt={album.title} className="card-album" /> */}
            {/* <p className="Album-Title">{album.title}</p> */}
            {/* <p>{album.year}</p> */}
            {/* </Link> */}

            <Link to="!#" className="album">
              <img src="images/artist.jpg" alt="album" className="card-album" />
              <p className="Album-Title">Heyo</p>
              {/* <p>{album.year}</p> */}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

// const mapStateToProps = (state) => ({
//   error: state.chart.error,
//   albums: state.chart.top.albums,
//   loading: state.chart.loading,
// });

// const mapDispatchToProps = (dispatch) =>
//   bindActionCreators(
//     {
//       fetchTopAlbums: fetchTopAlbumsAction,
//     },
//     dispatch
//   );

// export default connect(mapStateToProps, mapDispatchToProps)(ChartAlbums);
export default ChartAlbums;
